import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { permissions } from './../../constants'
import Storage from './../../services/Storage'
import handlePermission from './handlePermission'
import { alertError } from './../../services/dialog'

const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                let hasPermission = true;
                let path = props.match.path;
                let permission = rest.permission;

                if (permission && !handlePermission(permission)) {
                    hasPermission = false;
                }

                if (!hasPermission && path !== '/orders') {
                    return <Redirect to='/orders' />
                } else {
                    return <Component  {...props} />
                }
            }}
        />
    );
}

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/containers/app/private_route.js